/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import TextInput from '../common/TextInput';
import SelectInput from '../common/SelectInput';
import Button from '../common/Button';
import RadioInput from '../common/RadioInput';
import {Modal} from 'react-overlays';
import "../../styles/modals/removeEstablishmentModal.css";

const backdropStyle = {
  position: 'fixed',
  top: 0, bottom: 0, left: 0, right: 0,
  zIndex: 'auto',
  backgroundColor: '#000',
  opacity: 0.5
};
const EstablishmentRemovalForm = ({
  removalForm,
  establishment,
  hideRemovePage,
  showModal,
  onClick,
  onChange,
  onRemove
}) => {
  let questions = [];
  const date = new Date(establishment.created_timestamp);
  const formattedDate = `${(date.getUTCMonth() + 1).toString()}/${date.getDate().toString()}/${date.getUTCFullYear().toString()}`;
  if (removalForm.formQuestions) {
    removalForm.formQuestions.forEach(question => {
      let questionParts = [];
      question.questionParts.map(questionPart => {
        let type = questionPart.questionPartType;
        if (type === '1') { //multichoice checkbox
        } else if (type === '3') { //radio button
          questionParts.push(
            <span className="question-part"
                  key={questionPart.questionPartName}>
              <RadioInput
                onChange={onClick}
                label={questionPart.questionPartLabel}
                name={questionPart.questionPartName}
                className="establishment-radio-question col-xs-12 col-md-6 "
                fieldClass={questionPart.questionPartName}
                value={establishment[questionPart.questionPartName]}
                options={questionPart.questionPartOptions}
                tooltip={questionPart.questionPartTooltipHelp}
              />
              <div
                dangerouslySetInnerHTML={{__html: questionPart.questionPartContextHelp}}/>
            </span>
          );
        } else if (type === '4') { //text box
          questionParts.push(
            <span className="question-part"
                  key={questionPart.questionPartName}>
              <TextInput
                type="text"
                onChange={onChange}
                placeHolder={questionPart.questionPartLabel}
                label={questionPart.questionPartLabel}
                name={questionPart.questionPartName}
                className="establishment-text-input col-xs-12 col-md-6"
                fieldClass={questionPart.questionPartName}
                value={establishment[questionPart.questionPartName]}
                tooltip={questionPart.questionPartTooltipHelp}/>
              <div
                dangerouslySetInnerHTML={{__html: questionPart.questionPartContextHelp}}/>
            </span>
          );
        } else if (type === '6') { //select box
          questionParts.push(
            <span className="question-part"
                  key={questionPart.questionPartName}>
              <SelectInput
                name={questionPart.questionPartName}
                label={questionPart.questionPartLabel}
                onChange={onChange}
                value={establishment[questionPart.questionPartName]}
                options={questionPart.questionPartOptions}
                className={"establishment-select-input col-xs-12 col-lg-6 "
                  + questionPart.questionPartName}
                fieldClass={questionPart.questionPartName}
                defaultOption="Select"
                tooltip={questionPart.questionPartTooltipHelp}/>
              <div
                dangerouslySetInnerHTML={{__html: questionPart.questionPartContextHelp}}/>
            </span>
          );
        }
      });
      questions.push(
        <span className="question"
              key={question.questionID || question.questionName}>
          {question.questionGroupHelpText && <div
            dangerouslySetInnerHTML={{__html: question.questionGroupHelpText}}/>}
          {questionParts}
        </span>
      );
    });
  }
  return (
    <div className="remove-establishment-container"
         hidden={!establishment.id}>
      <Modal
        className="establishment-modal"
        backdropStyle={backdropStyle}
        show={showModal}
        onHide={hideRemovePage}
      >
        <div className="establishment-modal-dialog"
             id="remove-establishment-modal">

          <h4 id="remove-establishment-title">Confirm Removal of This
            Establishment</h4>
          <div className="removal-message">You have requested to remove the
            following establishment which was added on {formattedDate}:
          </div>
          <div id="establishment-info-container">
            <div className="establishment-name">
              <b>{establishment.establishment_name}</b></div>
            <div className="establishment-street-address">
                {establishment.address.street}
              </div>
            <div className="establishment-city-zip-state"> 
              {establishment.address.city + ", " +
              establishment.address.state + " " + establishment.address.zip}
            </div>
          </div>
          <form id="remove-establishment-container">
            {questions}
            <div className="remove-buttons-container">
                <a
                  disabled={false}
                  onClick={hideRemovePage}>
                  Cancel
                </a>
                <Button
                  value="Remove Establishment"
                  disabled={false}
                  onClick={onRemove}
                  className="remove-establishment-btn btn btn-primary"
                />
            </div>
          </form>
        </div>
      </Modal>
    </div>


  );
};
EstablishmentRemovalForm.propTypes = {
  removalForm: PropTypes.object,
  establishment: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  hideRemovePage: PropTypes.func.isRequired,
  showRemovePage: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  errors: PropTypes.object
};
export default EstablishmentRemovalForm;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentRemovalForm.js
 **/